<template>
  <div class="container">
    <section v-show="!showSuccess">
      <div v-if="amountEditable ">
        <h3 class="bold-font center">Payment {{amount | currency}}</h3>
        <div class="row">
          <div class="col s12 m4 input-field">
            <input 
              @input="updateAmounts"
              name="amount"
              id="amount"
              v-model='amount'
              step="0.01"
              type="text" 
              inputmode="decimal"
              class='inputText'
              lang="en-001">

              <label for="amount">Amount</label>
            </div>
          </div>
      </div>
      <div v-else>
        <h3 class="bold-font center">Payment {{amount | currency}}</h3>
      </div>

      <div class='large-font mt-5 center'>
        to: {{businessName}}
      </div>

      <div class="row">
        <div class="col s12 m6" v-if="invoiceFieldEnabled">
          <div v-if="presetInvoice.length > 0" class="large-font center mt-25">
            <i class="fas fa-file-invoice prefix grey-text"></i>
            Invoice: <span class="bold-font">{{invoice}}</span>
          </div>
          <div v-else class="input-field">
            <i class="fas fa-file-invoice prefix grey-text"></i>
            <input name="invoice" id="invoice" type="text" v-model="invoice" ref="invoice">

            <label for="invoice">Invoice</label>
          </div>
        </div>

        <div class="input-field col s12 m6" v-if="noteFieldEnabled">
          <i class="fas fa-sticky-note prefix grey-text"></i>
          <input name="note" id="note" type="text" v-model="note" ref="note">

          <label for="note">Note (Optional)</label>
        </div>
      </div>

      <div class="row" v-if="nameFieldEnabled">
        <div class="input-field col s12 m6">
          <i class="fas fa-user prefix grey-text"></i>
          <input name="first_name" id="first_name" type="text" v-model="firstName" ref="first_name" required>

          <label for="first_name">First Name</label>
        </div>

        <div class="input-field col s12 m6">
          <input name="last_name" id="last_name" type="text" v-model="lastName" ref="last_name" required>

          <label for="last_name">Last Name</label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 m6" v-if="emailFieldEnabled">
          <i class="fas fa-envelope prefix grey-text"></i>
          <input name="email" id="email" type="text" v-model="email" ref="email" required>

          <label for="email">Email</label>
        </div>

        <div class="input-field col s12 m6" v-if="phoneFieldEnabled">
          <i class="fas fa-phone prefix grey-text"></i>
          <input name="phone" id="phone" type="text" v-model="phone" ref="phone">

          <label for="phone">Mobile Phone</label>
        </div>
      </div>

      <section class='mt-10 grey-text center' v-if='showTips'>
        <tips :qid="merchantQid" :tips-updated="tipsUpdated"></tips>
      </section>

      <slot :update-token="updateToken"></slot>

      <div class="center mt-5" v-show="requirePolicyConsent">
        <label>
          <input type="checkbox" v-model="agreedToTerms" :disabled="showPending"/>
          <span>I agree with <a :href="policyUrl" target="_blank" class="">company policy</a>
          and to pay the above amount</span>
        </label>
      </div>
      <button @click="charge" v-show="!showPending" class="btn-large wide-btn mt-5" :disabled="!cardToken.token">
        pay <span v-show='amount'>{{withTipAmount}}</span>
      </button>

      <div class="center emerald mt-5 large-font bold-font" v-if="feeAmount > 0">
        Gross amount: <b>{{grossAmount | currency}}</b> |  
        Non-cash adj: <b>{{feeAmount | currency}}</b>
      </div>

      <center v-if='showPending' class='grey-text mt-25'>
        <i class="fas fa-spinner fa-spin"></i> Processing...
      </center>
    </section>
    <section v-show="showSuccess" class="mt-50 center">
      <h3 class='emerald bold-font'>
        <i class="fas fa-check fa-3x"></i><br>
        Successfully Paid
      </h3>
    </section>
  </div>
</template>
<script>
import tips from "../tips"

export default {
  components: {tips},
  props: [
    'paymentType',
    'presetAmount',
    'presetInvoice',
    'presetEmail',
    'presetPhone',
    'presetAddressZip',
    'presetFirstName',
    'presetLastName',
    'presetNote',
    'amountEditable',
    'invoiceEditable',
    'noteEditable',
    'businessName',
    'merchantQid',
    'showTips',
    'checkoutSessionId',
    'custom',
    'invoiceFieldEnabled',
    'noteFieldEnabled',
    'phoneFieldEnabled',
    'emailFieldEnabled',
    'addressFieldEnabled',
    'nameFieldEnabled',
    'requirePolicyConsent',
    'policyUrl'
  ],
  created() {
    this.$dom.watch() // to render icons
    this.updateAmounts()
    this.$nextTick(() => {
      M.updateTextFields();
    });
  },
  data() {
    return {
      amount: this.presetAmount,
      invoice: this.presetInvoice === '' ? null : this.presetInvoice,
      note: this.presetNote === '' ? null : this.presetNote,
      email: this.presetEmail === '' ? null : this.presetEmail,
      phone: this.presetPhone === '' ? null : this.presetPhone,
      firstName: this.presetFirstName === '' ? null : this.presetFirstName,
      lastName: this.presetLastName === '' ? null : this.presetLastName,
      selectedTip: null,
      grossAmount: null,
      feeAmount: 0,
      withTipAmount: null,
      tipAmount: null,
      tipAmountFormatted: null,
      cardToken: {},
      showPending: false,
      showSuccess: false,
      lastGrossCalcRequestId: 0,
      agreedToTerms: false
    }
  },
  methods: {
    tipsUpdated(selectedTip, tipCustomAmount) {
      this.selectedTip = selectedTip
      this.tipCustomAmount = tipCustomAmount
      this.updateAmounts()
    },
    updateAmounts() {
      this.lastGrossCalcRequestId++;
      const currentRequestId = this.lastGrossCalcRequestId;

      this.$http.get("/api/v1/vue/gross_calculations", {params: this.grossCalcParams}).then(response => {
        if (currentRequestId === this.lastGrossCalcRequestId) {
          this.grossAmount = response.body.gross_amount
          this.feeAmount = response.body.fee
          this.withTipAmount = response.body.amount_with_tip
          this.tipAmount = response.body.tip_amount
          this.tipAmountFormatted = response.body.tip_amount_formatted
        }
      })
    },
    charge() {
      if (this.requirePolicyConsent && !this.agreedToTerms) {
        this.notifyError("Please agree to the company policy before proceeding with payment")
        return
      }

      this.showPending = true
      this.$http.post("/api/v1/public/checkout_sessions/card_payments", this.chargeParams ).then(response => {
          this.showSuccess = true
          this.notifySuccess("Transaction successfully processed")
        }, error => {
          this.errorHandler(error)
          this.showPending = false
        })
    },
    updateToken(token) {
      this.cardToken = token
    }
  },
  computed: {
    grossCalcParams() {
      return {
        amount: this.amount,
        tip_percent: this.selectedTip,
        tip_custom_amount: this.tipCustomAmount,
        qid: this.merchantQid,
        funding: this.cardToken.funding
      }
    },
    chargeParams() {
      return {
        amount: this.amount,
        token: this.cardToken.token,
        note: this.note,
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        phone: this.phone,
        invoice: this.invoice,
        tip_percent: this.selectedTip,
        tip_amount: this.tipCustomAmount,
        checkout_session_id: this.checkoutSessionId,
        custom: this.custom
      }
    }
  },
  watch: {
    "cardToken.token": function(newVal, oldVal) {
      this.updateAmounts();
    }
  }
}
</script>
